<ng-container *ngIf="datosActualizacion$ | async as datos; else loading">
  <ng-container *ngIf="hijos$ | async as hijos">
    <div class="bigPage_cont">
      <div class="bigPage_header">
        <div class="actualizacion-header">
          <app-persona-card [persona]="datos.hijo"></app-persona-card>
          <div class="flex-wrap" style="margin-top: 16px;">
            <div *ngIf="hijos.length > 1">
              <button mat-button color="primary" [matMenuTriggerFor]="hijosMenu">Mis hijos</button>
              <mat-menu #hijosMenu="matMenu">
                <div *ngFor="let hijo of hijos">
                  <button *ngIf="datos.hijo.id !== hijo.id" mat-menu-item
                  (click)="navegarHijo(hijo.id)">{{hijo.nombresApellidos}}</button>
                </div>
              </mat-menu>
            </div>
            <button mat-button color="primary" (click)="volver()">Volver</button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="returnUrl === 'stepper';else sidenav">
      <div class="update-container mat-elevation-z4">
        <div *ngIf="guardando$ | async as guardando">
          <mat-stepper orientation="vertical" linear=false>
            <mat-step>
                <h2 class="mat-h2">Datos de contacto</h2>
                <form [formGroup]="datosUbicacionForm">
                  <div *ngIf="hijos.length > 1" style="margin: 0 0 16px 0">
                    <mat-checkbox formControlName="todosCheck" color="primary">Usar para todos mis hijos</mat-checkbox>
                  </div>
                </form>
                <app-datos-ubicacion [datosUbicacionForm]="datosUbicacionForm"></app-datos-ubicacion>
                <button mat-button [disabled]="datosUbicacionForm.pristine || guardando"
                  (click)="guardarForm(datosUbicacionForm, 'ubicacion')">Guardar</button>
                <mat-spinner *ngIf="guardando === 'true'" [mode]="'indeterminate'"></mat-spinner>
                <button mat-button matStepperNext>Siguiente</button>
            </mat-step>
            <mat-step *ngFor="let form of datosPadresForm">
              <h2 class="mat-h2">{{labelPadres(form.get('genero').value)}}</h2>
              <form [formGroup]="form">
              </form>
              <app-datos-padres [datosPadresForm]="form"></app-datos-padres>
              <button mat-button [disabled]="form.pristine || guardando"
                (click)="guardarForm(form, form.get('id').value)">Guardar</button>
              <mat-spinner *ngIf="guardando === 'true'" [mode]="'indeterminate'"></mat-spinner>
              <button mat-button matStepperPrevious>Atras</button>
              <button mat-button matStepperNext>Siguiente</button>
            </mat-step>
            <mat-step>
              <h2 class="mat-h2">Datos del acudiente</h2>
                <form [formGroup]="datosAcudienteForm">
                  <div *ngIf="hijos.length > 1" style="margin: 0 0 16px 0">
                    <mat-checkbox formControlName="todosCheck" color="primary">Usar para todos mis hijos</mat-checkbox>
                  </div>
                </form>
                <app-datos-acudiente [datosAcudienteForm]="datosAcudienteForm"></app-datos-acudiente>
                <button mat-button [disabled]="datosAcudienteForm.pristine || guardando"
                  (click)="guardarForm(datosAcudienteForm, 'acudiente')">Guardar</button>
                <mat-spinner *ngIf="guardando === 'true'" [mode]="'indeterminate'"></mat-spinner>
                <button mat-button matStepperPrevious>Atras</button>
            </mat-step>
          </mat-stepper>
        </div>
      </div>
    </div>
    <ng-template #sidenav>
      <mat-sidenav-container class="update-container mat-elevation-z4">
        <mat-sidenav #sidenav mode="side" opened fixedInViewport=false fixedTopGap=0
          fixedBottomGap=0 position="end">
          <!-- <a (click)="navegarView('basico')" class="update-section-link">Datos de registro</a> -->
          <a (click)="navegarView('ubicacion')" class="update-section-link">Datos de contacto</a>
          <div *ngFor="let form of datosPadresForm">
            <a (click)="navegarView(form.get('id').value)" class="update-section-link">{{labelPadres(form.get('genero').value)}}</a>
          </div>
          <a (click)="navegarView('acudiente')" class="update-section-link">Datos del acudiente</a>
        </mat-sidenav>
        <!-- TODO: En un futuro mejorar la encapsulacion de cada paso -->
        <mat-sidenav-content class="update-info-container">
          <div *ngIf="currentView$ | async as view">
            <div *ngIf="guardando$ | async as guardando">
              <ng-container *ngIf="view === 'basico'">
                <h2 class="mat-h2">Datos de registro</h2>
                <app-datos-basicos [datosBasicosForm]="datosBasicosForm"></app-datos-basicos>
                <button mat-button [disabled]="datosBasicosForm.pristine || guardando"
                  (click)="guardarForm(datosBasicosForm, 'basicos')">Guardar</button>
                <mat-spinner *ngIf="guardando === 'true'" [mode]="'indeterminate'"></mat-spinner>
              </ng-container>
              <ng-container *ngIf="view === 'ubicacion' || view === 'default'">
                <h2 class="mat-h2">Datos de contacto</h2>
                <form [formGroup]="datosUbicacionForm">
                  <div *ngIf="hijos.length > 1" style="margin: 0 0 16px 0">
                    <mat-checkbox formControlName="todosCheck" color="primary">Usar para todos mis hijos</mat-checkbox>
                  </div>
                </form>
                <app-datos-ubicacion [datosUbicacionForm]="datosUbicacionForm"></app-datos-ubicacion>
                <button mat-button [disabled]="datosUbicacionForm.pristine || guardando"
                  (click)="guardarForm(datosUbicacionForm, 'ubicacion')">Guardar</button>
                <mat-spinner *ngIf="guardando === 'true'" [mode]="'indeterminate'"></mat-spinner>
              </ng-container>
              <ng-container *ngFor="let form of datosPadresForm">
                <ng-container *ngIf="+view === +form.get('id').value">
                  <h2 class="mat-h2">{{labelPadres(form.get('genero').value)}}</h2>
                  <form [formGroup]="form">
                    <!-- <div *ngIf="hijos.length > 1" style="margin: 0 0 16px 0">
                      <mat-checkbox formControlName="todosCheck" color="primary">Usar para todos mis hijos</mat-checkbox>
                    </div> -->
                  </form>
                  <app-datos-padres [datosPadresForm]="form"></app-datos-padres>
                  <button mat-button [disabled]="form.pristine || guardando"
                    (click)="guardarForm(form, form.get('id').value)">Guardar</button>
                  <mat-spinner *ngIf="guardando === 'true'" [mode]="'indeterminate'"></mat-spinner>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="view === 'acudiente'">
                <h2 class="mat-h2">Datos del acudiente</h2>
                <form [formGroup]="datosAcudienteForm">
                  <div *ngIf="hijos.length > 1" style="margin: 0 0 16px 0">
                    <mat-checkbox formControlName="todosCheck" color="primary">Usar para todos mis hijos</mat-checkbox>
                  </div>
                </form>
                <app-datos-acudiente [datosAcudienteForm]="datosAcudienteForm"></app-datos-acudiente>
                <button mat-button [disabled]="datosAcudienteForm.pristine || guardando"
                  (click)="guardarForm(datosAcudienteForm, 'acudiente')">Guardar</button>
                <mat-spinner *ngIf="guardando === 'true'" [mode]="'indeterminate'"></mat-spinner>
              </ng-container>
            </div>
          </div>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </ng-template>
  </ng-container>
</ng-container>
<ng-template #loading>
  <mat-spinner [mode]="'indeterminate'"></mat-spinner>
</ng-template>
<custom-alert></custom-alert>
